import { render, staticRenderFns } from "./Newdashboard.vue?vue&type=template&id=14024978&scoped=true"
import script from "./Newdashboard.vue?vue&type=script&lang=js"
export * from "./Newdashboard.vue?vue&type=script&lang=js"
import style0 from "./Newdashboard.vue?vue&type=style&index=0&id=14024978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14024978",
  null
  
)

export default component.exports